import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandL } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Section, StyledContainer, Title } from '#src/Careers/ui.tsx';

const TitleWrapper = styled.div`
  @media ${laptopAndAbove} {
    width: 30%;
  }
`;

const DescriptionWrapper = styled(Vertical)`
  @media ${laptopAndAbove} {
    max-width: 50%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  @media ${laptopAndAbove} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: var(--quadruple-unit);
  }
`;

export const Values = () => {
  return (
    <Section $spacing>
      <StyledContainer>
        <Title>Our Values</Title>
        <Vertical gap={8}>
          <Container>
            <TitleWrapper>
              <BrandL as="h3">Own Your Game</BrandL>
            </TitleWrapper>
            <DescriptionWrapper>
              <BodyM bold>
                Think and act like an owner, and expect your teammates to do the
                same.
              </BodyM>
              <BodyM>
                Demand excellence from yourself and your teammates in order to
                own and change the game. See beyond your own work and keep the
                long view for Sorare and the fans.
              </BodyM>
            </DescriptionWrapper>
          </Container>
          <Container>
            <TitleWrapper>
              <BrandL as="h4">Build with the fans, and for the fans</BrandL>
            </TitleWrapper>
            <DescriptionWrapper>
              <BodyM bold>
                Have an obsession for high-quality user experiences.
              </BodyM>
              <BodyM>
                Delight customers and turn them into Sorare fans. Engage with
                our community with transparency to build trust, and learn from
                the fans to deliver effective changes. Do everything to retain
                and reward the trust they put in us.
              </BodyM>
            </DescriptionWrapper>
          </Container>
          <Container>
            <TitleWrapper>
              <BrandL as="h3">Win as a Team</BrandL>
            </TitleWrapper>
            <DescriptionWrapper>
              <BodyM bold>We are all in this together as one team.</BodyM>
              <BodyM>
                Sorare is a collective where team members share the same passion
                for the game and limitless ambition, grounded in humility, to
                drive the company and product forward. Sorare employees all have
                an equal opportunity to participate and cultivate change.
              </BodyM>
            </DescriptionWrapper>
          </Container>
        </Vertical>
      </StyledContainer>
    </Section>
  );
};
